import React from 'react'
import { Box, Image, Heading, Text } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

const AdvantageCard = ({ src, type }) => {
  const { t } = useTranslation('liveblog')

  return (
    <Box
      type={type}
      height={['auto', 'auto', '380px']}
      maxWidth="360px"
      width={1}
      mt={[0, 0, '-280px']}
      pt={6}
      px={8}
      pb={8}
      bg="white"
      sx={{
        boxShadow: '0px 30px 80px rgba(33, 47, 64, 0.1)',
        borderRadius: '10px',

        '@media (max-width: 80rem)': {
          '&:first-child': {
            mt: '-920px'
          }
        }
      }}
    >
      <Image src={src} height="145px" mb={5} />

      <Heading as="h3" variant="level3" fontSize="24px" lineHeight="130%" mb={4}>
        {t(`advantage.cards.${type}.title`)}
      </Heading>

      <Text as="p" variant="level6">
        {t(`advantage.cards.${type}.description`)}
      </Text>
    </Box>
  )
}

AdvantageCard.propTypes = {
  type: PropTypes.string,
  src: PropTypes.any
}

export default AdvantageCard
